/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_No_Teams_Get_StartedInputs */



/**
* | output |
* | --- |
* | "Get started by creating the first team of your organization" |
*
* @param {Teams_No_Teams_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_no_teams_get_started = /** @type {((inputs?: Teams_No_Teams_Get_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_No_Teams_Get_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beginne damit, ein Team für deine Organisation zu erstellen")
	return /** @type {LocalizedString} */ ("Get started by creating the first team of your organization")
});